module.exports = "/packs/media/images/StartBusiness-4798e9c78537b4f485d5b0aa4897cd74.png";